"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/objectSpread2.js"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.function.name.js");

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'NavItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    projectId: {
      type: Number,
      default: 0
    },
    reportId: {
      type: Number,
      default: 0
    }
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['vipLevel', 'isVip'])),
  methods: {
    goto: function goto(item) {
      if (item.disabled) return;
      this.$router.push({
        name: item.name,
        params: {
          projectId: this.projectId,
          reportId: this.reportId
        }
      });
    },
    checkVipAllow: function checkVipAllow(itemVipLevel) {
      return this.isVip && this.vipLevel >= itemVipLevel;
    }
  }
};
exports.default = _default;